/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpFromBracket: {
  name: 'arrow-up-from-bracket';
  data: string;
} = {
  name: 'arrow-up-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.354.646a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 2.207V11a.5.5 0 0 0 1 0V2.207l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3ZM1.5 13a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v1.5h-13V13Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
